import React, { useEffect, useRef } from "react";
import { VEHICLES, THEME_COLORS } from "../game/config";
import { paintVehicle } from "../game/render";

export function VehiclePreview({ tier = 0, theme = "classic", size = 220, spin = true }) {
  const ref = useRef(null);
  useEffect(() => {
    const cv = ref.current;
    const ctx = cv.getContext("2d");
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    cv.width = size * dpr; cv.height = size * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    const v = VEHICLES[Math.min(tier, VEHICLES.length - 1)];
    const color = THEME_COLORS[theme] || v.body;
    const cx = size / 2, cy = size / 2;
    const r = Math.min(size * 0.3, v.radius * 2.0);
    let angle = -Math.PI / 4;
    let t = 0;
    let raf;

    const drawPlatform = () => {
      // circular showroom disc with a soft coloured glow — reads as a turntable.
      const py = cy + size * 0.20;
      const rad = size * 0.42;
      const g = ctx.createRadialGradient(cx, py, size * 0.02, cx, py, rad);
      g.addColorStop(0, "rgba(255,255,255,0.14)");
      g.addColorStop(0.35, hexA(color, 0.20));
      g.addColorStop(1, "rgba(10,14,26,0)");
      ctx.save();
      ctx.translate(cx, py);
      ctx.scale(1, 0.34);
      ctx.fillStyle = g;
      ctx.beginPath(); ctx.arc(0, 0, rad, 0, 6.28); ctx.fill();
      ctx.strokeStyle = hexA(color, 0.5); ctx.lineWidth = 2;
      ctx.beginPath(); ctx.arc(0, 0, rad * 0.82, 0, 6.28); ctx.stroke();
      ctx.restore();
    };

    const draw = () => {
      ctx.clearRect(0, 0, size, size);
      drawPlatform();

      const bob = Math.sin(t) * size * 0.012;

      // contact shadow under the car (grounds it for a faux-3D feel)
      ctx.save();
      ctx.translate(cx, cy + size * 0.20);
      ctx.scale(1, 0.30);
      ctx.fillStyle = "rgba(0,0,0,0.45)";
      ctx.beginPath(); ctx.arc(0, 0, r * 1.15, 0, 6.28); ctx.fill();
      ctx.restore();

      // the vehicle itself, floating slightly above the platform
      ctx.save();
      ctx.translate(cx, cy + bob);
      ctx.rotate(angle);
      ctx.shadowColor = color; ctx.shadowBlur = 26; ctx.shadowOffsetY = 0;
      paintVehicle(ctx, { tier: Math.min(tier, VEHICLES.length - 1), color, wheelColor: "#141414", radius: r, theme });
      ctx.restore();

      t += 0.05;
      if (spin) { angle += 0.006; raf = requestAnimationFrame(draw); }
    };

    if (spin) draw();
    else draw();
    return () => cancelAnimationFrame(raf);
  }, [tier, theme, size, spin]);
  return <canvas ref={ref} style={{ width: size, height: size }} data-testid="vehicle-preview" />;
}

function hexA(hex, a) {
  if (!hex || hex[0] !== "#" || hex.length !== 7) return `rgba(255,149,0,${a})`;
  const r = parseInt(hex.slice(1, 3), 16), g = parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${a})`;
}
